module.exports = __webpack_public_path__ + "static/media/iron-blocks.f40b60e3.png";